import type { PropsWithChildren } from "react"
import { MouseEvent, useEffect, useState } from "react"
import { isEnabled } from "common/components/Didomi"
import { linkClassNames } from "common/components/Footer"

/**
 * Renders Didomi's consent preferences link.
 * It renders nothing until Didomi is enabled, has finished loading, and the
 * visitor is under a consent regulation (mirrors the equivalent Stimulus
 * controller: rails/app/assets/javascripts/controllers/didomi_preferences_controller.js).
 */
export const ConsentPreferencesLink = ({
  title,
  children,
}: PropsWithChildren<{ title?: string }>) => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!isEnabled()) return

    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(() => {
      if (window.Didomi.getCurrentUserStatus().regulation !== "none") {
        setIsReady(true)
      }
    })
  }, [])

  if (!isEnabled() || !isReady) {
    return null
  }

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    window.Didomi.preferences.show()
  }

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a title={title} href="#" onClick={onClick} className={linkClassNames}>
      {children}
    </a>
  )
}
